export function hasWindow(): boolean {
  return typeof window !== 'undefined';
}
